<template>
  <div class="refcontainer" :class="{'active':refs}">
    <div class="close" @click="goBack">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L27 27M27 1L1 27" stroke="#AD6766"/>
      </svg>
    </div>
    <div class="referenzen">
      <!--            <div class="scroller">-->
      <div class="d-flex flex-wrap">
        <router-link :to="goToProject(p.slug)" :key="p.slug" class="redcard" v-for="p in projects">
          <div class="img"
               :style="{ backgroundImage: `url(${p._embedded['wp:featuredmedia']['0'].source_url})` }"></div>
          <div class="desc">
            <div class="kunde"> {{ p.acf.menubezeichnung }}</div>
          </div>
        </router-link>
      </div>
      <!--            </div>-->
    </div>
  </div>
</template>
<script>
import store from '@/store'

export default {
  store,
  name: 'Referenzen',
  created: function () {
    store.dispatch('getProjects');
  },
  props: {
    msg: String,
    pages: Array,
    refs: Boolean,
  },
  computed: {
    projects() {
      return store.state.projects.filter(p=>!p.acf.ausblenden)
    },
  },

  methods: {
    goToProject(slug) {
      return "/projekte/" + slug;
    },
    goBack() {
      this.$emit('update:refs', false)
      // this.$router.push('/')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scroller {
}

.refcontainer {
  position: fixed;
  /*.shadowed {*/
  z-index: 100000;
  @include mobile {
    z-index: 2000000;
  }
  top: 72px;
  right: 0;
  width: 650px;
  height: calc(100vh - 72px);
  transform: translateX(100%);
  transition: transform 0.1s ease-out;
  overflow-y: scroll;
  backdrop-filter: blur(10px);
  background: rgba(#F8F8F8, 0.85);

  /*padding-bottom: 100px;*/
  @include mobile {
    width: 100%;
  }

  &.active {
    transform: translateX(0);
    box-shadow: 5px 15px 50px rgba(0, 0, 0, 0.15);
  }

  .close {
    position: sticky;
    right: 18px;
    top: 35px;
    padding: 10px;
    background-color: transparent;
    cursor: pointer;
    z-index: 30;
    @include mobile {
      background: #fff;
    }
  }
}

.referenzen {
  position: absolute;
  width: 500px;
  right: 70px;
  top: 100px;
  @include touch {
    padding-bottom: 10%;
  }
  @include mobile {
    width: 100%;
    right: 0;
  }

  .row {
    position: relative;
  }
}

a {
  color: #42b983;
}

.redcard {
  width: 220px;
  margin: 10px 15px 20px 15px;
  background-color: #fff;
  height: 240px;
  @include mobile {
    width: calc(50% - 30px);
    height: 190px;
  }
  background-size: auto 100%;
  background-repeat: no-repeat;
  border-radius: 5%;
  /* ZZ - Rostrot - heller */
  /*background: #AD6766;*/
  /* shadow far */
  background-position: center;
  overflow: hidden;
  box-shadow: 5px 10px 50px rgba(0, 0, 0, 0.1), 2px 4px 10px rgba(0, 0, 0, 0.05);

  .desc {
    .kunde {
      font-family: $sansmed;
      //styleName: <strong> - Hervorhebung;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.02em;
      text-align: left;

    }

    display: flex;
    justify-content: space-between;
    padding: 10px;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: #4D4D4D;
  }

  .img {
    height: 200px;
    width: 220px;
    @include mobile {
      width: 100%;
      height: calc(100% - 50px);
    }
    display: block;

    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
  }
}
</style>
